// Cola de impresión de etiquetas.
//
// La app NO le habla directo a la impresora (el navegador no puede, y encima
// está en HTTPS). En su lugar, al confirmar el control se ENCOLA un trabajo en
// la colección `printJobs` de Firestore. Un "agente de impresión" corriendo en
// la PC-puente (ver carpeta /print-agent) escucha esa cola y manda la etiqueta
// a la impresora TSC por USB.

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import { getDireccionCliente } from "./etiquetasFS";

/**
 * Encola la impresión de las etiquetas de un pedido (bultos + paquetes).
 * @param {object} pedido  documento del pedido (id, numero, cliente, deposito, clienteCodigo)
 * @param {object} opts    { bultos, paquetes, uid }
 * @returns {Promise<string>} id del trabajo encolado
 */
export async function encolarEtiquetas(pedido, { bultos = 0, paquetes = 0, uid = null } = {}) {
  // Dirección del cliente para la etiqueta de info (best-effort).
  let dir = null;
  try { dir = await getDireccionCliente(pedido?.clienteCodigo); } catch (_) {}

  const ref = await addDoc(collection(db, "printJobs"), {
    status: "pending",           // pending → printing → done | error
    tipo: "etiquetas",
    deposito: pedido?.deposito || "R8",
    pedidoId: pedido?.id || null,
    numero: pedido?.numero || pedido?.id || null,
    cliente: pedido?.cliente || "",
    clienteCodigo: pedido?.clienteCodigo || null,
    direccion: dir?.direccion || "",
    localidad: dir?.localidad || "",
    bultos: Number(bultos) || 0,
    paquetes: Number(paquetes) || 0,
    createdAt: serverTimestamp(),
    createdBy: uid || null,
  });
  return ref.id;
}
